
import * as _ from 'lodash-es';
import { BasketArticleDto } from '../../../shared/service-proxies/service-proxies';


export class BaseStep {
    //Name of step
    name: string;
    //stepName of step
    stepName: string;
    //translation key
    translationLabel: string;
    //Flag which shows stete of current step
    isCompleted: boolean = false;

    private _stepOrder: number;
    get stepOrder(): number {
        return this._stepOrder;
    }
    set stepOrder(step: number) {
        this._stepOrder = step;
    }

    //detect if this step already was passed
    isDirty: boolean = false;

    //css class for state
    get stepState(): string {
        if (this.isCompleted) {
            return 'complete';
        } else {
            if (!this.isDirty) {
                return 'new'
            }

            return 'in-progress';
        }
    }

    constructor(stepName: string, name: string, translationLabel?: string, step?: number) {
        this.stepName = stepName;
        this.name = name;

        if (translationLabel) {
            this.translationLabel = translationLabel;
        }

        if (step != null || step != undefined) {
            this.stepOrder = step;
        }
    }

    setComplitedState() {
        this.isCompleted = true;
    }

    setInProgressState() {
        this.isCompleted = false;

        this._setDirty();
    }

    private _setDirty() {
        this.isDirty = true;
    }
}


export class ConfirmOrderStep extends BaseStep {

}


export class ConfirmOrderModel {

    //#region Steps
    steps: ConfirmOrderStep[] = [];

    get totalSteps(): number {
        return this.steps.length;
    }

    //#region Steps


    //#region Current Step
    currentStep: ConfirmOrderStep;

    get stepNumber(): number {
        return _.indexOf(this.steps, this.currentStep);
    }

    //#region Current Step

    get stepName(): string {
        return this.currentStep.stepName;
    }

    private _basket: BasketArticleDto[];

    constructor(basket: BasketArticleDto[]) {
        this._basket = basket;

        this._initSteps();
        this._initFirstStep();
    }

    //Init all steps for Confirm order
    private _initSteps() {
        if (!this.steps) {
            this.steps = [];
        }

        const steps: any[] = [
            {
                stepName: 'TransportStep',
                title: 'Shipping options',
                translationLabel: 'Axilla.Apps.Webshop.App.ConfirmOrder.TransportStep',
                dissabled: false,
                permission: ''
            },
            {
                stepName: 'AdditionalArticlesStep',
                title: 'Export documents',
                translationLabel: 'Axilla.Apps.Webshop.App.ConfirmOrder.AdditionalArticlesStep',
                dissabled: false,
                permission: ''
            },
            {
                stepName: 'AgreementStep',
                title: 'Terms and Conditions',
                translationLabel: 'Axilla.Apps.Webshop.App.ConfirmOrder.AgreementStep',
                dissabled: false,
                permission: ''
            },
            {
                stepName: 'SummaryStep',
                title: 'Summary and Check out',
                translationLabel: 'Axilla.Apps.Webshop.App.ConfirmOrder.SummaryStep',
                dissabled: false,
                permission: ''
            },
            {
                stepName: 'PaymentStep',
                title: 'Payment',
                translationLabel: 'Axilla.Apps.Webshop.App.ConfirmOrder.PaymentStep',
                dissabled: true,
                permission: ''
            }
        ]


        if (this._basket.length > 2) {
            let backupOrderStep = {
                stepName: 'BackorderStep',
                title: 'Backorder',
                translationLabel: 'Axilla.Apps.Webshop.App.ConfirmOrder.Backorder',
                dissabled: false,
                permission: ''
            }

            this.steps.push(new ConfirmOrderStep(backupOrderStep.stepName, backupOrderStep.title, backupOrderStep.translationLabel, 0));
        }

        for (let i = 0; i < steps.length; i++) {
            const step = steps[i];

            if (step.dissabled) continue;

            this.steps.push(new ConfirmOrderStep(step.stepName, step.title, step.translationLabel, i));
        }

    }



    //Init first step for Confirm order
    private _initFirstStep() {
        if (this.steps.length > 0) {
            this.currentStep = this.steps[0];
            this.currentStep.setInProgressState();
        }
    }



    getStepState(stepNumber: number): string {
        return 'new';
        //if (stepNumber == this.stepOrder) {
        //    return this.stepState;
        //} else {
        //    return 'new';
        //}
    }


    next() {
        //check some condition
        if (true) {
            //set in completed state current step
            this.currentStep.setComplitedState();
            //select next step
            this._getNextStep();
            //set in progres current step
            this.currentStep.setInProgressState();
        }
    }

    prev() {
        //set in progres current step
        this.currentStep.setInProgressState();
        //select previous step
        this._getPrevStep();
        //set in progres current step
        this.currentStep.setInProgressState();
    }

    checkIfNextStepAvilable(): boolean {
        if (this.totalSteps >= this.stepNumber && this.stepNumber >= 0) {
            return true;
        }

        return false;
    }
    checkIfPrevStepAvilable(): boolean {
        if (this.stepNumber <= this.totalSteps && this.stepNumber >= 0) {
            return true;
        }

        return false;
    }

    private _getNextStep() {
        if (this.checkIfNextStepAvilable()) {
            this.currentStep = this.steps[this.stepNumber + 1];
        }

    }


    private _getPrevStep() {
        if (this.checkIfPrevStepAvilable()) {
            this.currentStep = this.steps[this.stepNumber - 1];
        }
    }



}
